import { render, staticRenderFns } from "./projectForm.vue?vue&type=template&id=23ad3e38&scoped=true"
import script from "./projectForm.vue?vue&type=script&lang=js"
export * from "./projectForm.vue?vue&type=script&lang=js"
import style0 from "./projectForm.vue?vue&type=style&index=0&id=23ad3e38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad3e38",
  null
  
)

export default component.exports